module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_1000000.d54cb2de.png";